export default "__VITE_ASSET__6$EKtIrt__"